import useCurrencyStore from "./useCurrencyStore";
import useOrgStore from "./useOrgStore";
import useUserStore from "./useUserStore";
import useAppConfigStore from "./useAppConfigStore";
import useTermsStore from "./useTermsStore";
import useFeatureStore from "./useFeatureStore";
import useFilterStore from "./useFilterStore";
import { useQuickAddStore } from "./quickAddStore";
import useSidebarStore from "./sidebarStore";

export const resetAllStores = () => {
  // 1. Clear Data Stores
  useUserStore.getState().clearUser();
  useOrgStore.getState().clearOrganization();
  useCurrencyStore.getState().clearCurrencySymbol();
  useAppConfigStore.getState().resetAppConfig();
  useTermsStore.getState().clearTerms();
  useFeatureStore.getState().clearFeatures();

  // 2. Clear UI & Utility Stores
  useFilterStore.getState().clearAllFilters();
  useQuickAddStore.getState().resetToDefaults();
  useSidebarStore.getState().clearSelectedPath();

  console.log("All Zustand stores have been reset.");
};
